import $ from 'jquery';
import flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-bg-lazyload';

// Custom

import CarouselObserver from '~/custom/carouselObserver';
import FancyboxCarousel from '~/custom/fancyboxCarousel';

$('.carousel').each(function() {
    var carousel = $(this),
        carouselOptions = {
            arrowShape: 'm 0.012,50.188084 c 0.008,2.869316 1.243075,5.598478 3.395203,7.499053 l 46.627738,40.990671 c 2.503505,2.047012 6.180467,1.745502 8.316217,-0.681917 2.135749,-2.427421 1.96274,-6.108391 -0.391296,-8.325281 L 21.934837,58.007933 C 21.611378,57.721309 21.498633,57.265 21.651379,56.86095 c 0.15275,-0.404042 0.539287,-0.672029 0.971683,-0.67362 h 71.382681 c 3.317164,0 6.006257,-2.685955 6.006257,-5.999246 0,-3.313292 -2.689093,-5.999247 -6.006257,-5.999247 H 22.635567 c -0.43213,-0.0041 -0.817296,-0.273082 -0.969642,-0.677012 -0.152333,-0.403916 -0.04042,-0.859854 0.281416,-1.147754 L 57.972367,10.701392 C 59.688281,9.31705 60.506469,7.104662 60.10358,4.938575 59.700693,2.772483 58.141554,1.001242 56.042349,0.32484995 53.943146,-0.35154605 51.641654,0.17576595 50.047446,1.698358 L 3.411375,42.689029 C 1.256817,44.588195 0.01943,47.317879 0.012,50.188084 Z',
            cellSelector: '.carousel__slide',
            initialIndex: '.carousel__slide--initial',
            imagesLoaded: false,
            prevNextButtons: false,
            pageDots: false,
        };

    // Thumb carousels
    if (carousel.is('[data-flickity-as-nav-for]')) {
        $.extend(true, carouselOptions, {
            asNavFor: carousel.data('flickity-as-nav-for'),
            contain: true,
            pageDots: false,
            prevNextButtons: false
        });
    }

    // Button carousels
    if (carousel.hasClass('carousel--buttons')) {
        $.extend(true, carouselOptions, {
            prevNextButtons: true,
        });
    }

    // Page dots carousels
    if (carousel.hasClass('carousel--page-dots')) {
        $.extend(true, carouselOptions, {
            pageDots: true,
        });
    }

    // Wrap around carousels
    if (carousel.hasClass('carousel--wrap-around')) {
        $.extend(true, carouselOptions, {
            wrapAround: true,
        });
    }

    // Cell align carousels
    if (carousel.hasClass('carousel--cell-align-left')) {
        $.extend(true, carouselOptions, {
            cellAlign: 'left',
        });
    }

    // Cell align carousels
    if (carousel.hasClass('carousel--cell-align-center')) {
        $.extend(true, carouselOptions, {
            cellAlign: 'center',
        });
    }

    // Contain carousels
    if (carousel.hasClass('carousel--contain')) {
        $.extend(true, carouselOptions, {
            contain: true,
        });
    }

    // Watch css carousels
    if (carousel.hasClass('carousel--watch-css')) {
        $.extend(true, carouselOptions, {
            watchCSS: true,
        });
    }

    // Disable drag vehicle images carousel
    if (carousel.hasClass('carousel--vehicle-images')) {
        $.extend(true, carouselOptions, {
            draggable: false
        });
    }

    // Instantiate
    const flkty = new flickity(this, carouselOptions);

    if (carousel.hasClass('carousel--fancybox')) {
        new FancyboxCarousel(this, flkty);
    }

    if (carousel.hasClass('carousel--observed')) {
        new CarouselObserver(this);
    }
});
